import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import style from '../style.module.scss';

const NO_INFO = 'No Info Available';

const REF_CHECK_ROWS = [
  { key: 'status', label: 'Status' },
  { key: 'delta_x', label: 'Delta x (px)' },
  { key: 'delta_y', label: 'Delta y (px)' },
  { key: 'euclidean_distance', label: 'Distance (px)' },
  { key: 'frame_comparison_url', label: 'Comparison image' },
];

const getRefCheckDisplayValue = (camera, key) => {
  const r = camera?.refCheckResult;
  if (!r) return null;
  const v = r[key];
  if (v == null && key !== 'status') return null;
  if (key === 'status') {
    return r.status || (r.error ? 'failed' : null);
  }
  if (key === 'frame_comparison_url' && typeof v === 'string') {
    return (
      <a href={v} target="_blank" rel="noopener noreferrer">
        View
      </a>
    );
  }
  if (key === 'delta_x' || key === 'delta_y') {
    return v != null ? `${v.toFixed(2)}` : null;
  }
  if (key === 'euclidean_distance') {
    return v != null ? `${v.toFixed(2)}` : null;
  }
  return v != null ? String(v) : null;
};

const RefCheckCell = ({ rowKey, value }) => {
  let content = value == null ? NO_INFO : value;
  if (rowKey === 'status' && content !== NO_INFO) {
    content = <span>{content}</span>;
  }

  return (
    <div className="form-group">
      <div className="form-row justify-content-center">
        <pre className="m-0 d-flex flex-column justify-content-around text-center">
          {content}
        </pre>
      </div>
    </div>
  );
};

const RefCheckRow = ({ cameras, refCheckHandler, refCheckLoadingCamera }) => (
  <>
    <tr>
      <td colSpan={cameras.length + 1} className={style.ThemeYellowBackground}>
        Ref Check
      </td>
    </tr>
    <tr className={style.TopLabel}>
      <td className={style.SideLabel}>Ref Check</td>
      {cameras.map((camera) => {
        const isRefCheckLoading = refCheckLoadingCamera === camera.cameraKey;
        return (
          <td key={camera._id}>
            <div className="form-group">
              <div className="form-row justify-content-center">
                <Button
                  className={style.Button}
                  size="sm"
                  variant="outline-primary"
                  onClick={() => refCheckHandler(camera.cameraKey)}
                  disabled={isRefCheckLoading}
                >
                  {isRefCheckLoading ? (
                    <>
                      <Spinner as="span" animation="border" size="sm" className="mr-1" />
                      Running…
                    </>
                  ) : (
                    'Run Ref Check'
                  )}
                </Button>
              </div>
            </div>
          </td>
        );
      })}
    </tr>
    {REF_CHECK_ROWS.map(({ key, label }) => (
      <tr key={key} className={style.TopLabel}>
        <td className={style.SideLabel}>{label}</td>
        {cameras.map((camera) => {
          const value = getRefCheckDisplayValue(camera, key);
          return (
            <td key={camera._id}>
              <RefCheckCell rowKey={key} value={value} />
            </td>
          );
        })}
      </tr>
    ))}
  </>
);

export default RefCheckRow;
